class Footer {
    constructor(context, settings, $, debounce) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;

        this.$window = this.$(window);
        this.$footer = this.$('.js-footer', this.context);
        this.$footerPlaceholder = this.$('.js-footer-placeholder', this.context);
        this.stickyHeaderHeight = this.$('.js-header').outerHeight();

        this.$window.on('load resize', debounce(() => {
            this.footerPlaceholderHeight();
            this.checkFooterHeight();
        }, 300));

        this.$window.on('scroll', () => {
            this.updateOnScroll();
        });

        this.$window.on('load', () => {
            if ('IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window) {

                if (this.$footer.length) {
                    this.observeFooter();
                }

                this.$footer.removeClass('is-visible');
            } else {
                this.$footer.addClass('is-visible');
            }
        });
    }

    footerPlaceholderHeight() {
        const footerHeight = this.$footer.outerHeight(true);

        // Subtracting 1 to prevent a gap between main and footer.
        this.$footerPlaceholder.height(footerHeight - 1);
    }

    checkFooterHeight() {
        // If the footer is taller than the window, start the footer position from
        // the top
        if (this.$footer.outerHeight(true) > this.$window.innerHeight()) {
            this.$footer.css('bottom', 'unset');
            this.$footer.css('top', this.stickyHeaderHeight);
        } else {
            this.$footer.css('bottom', 0);
            this.$footer.css('top', 'unset');
        }
    }

    updateOnScroll() {
        // Find the position of the placeholder, relative to the window
        let placeholderTop = this.$footerPlaceholder.offset()?.top - this.$window.scrollTop();

        // Set the top position of the footer to be the position of the placeholder
        // (minus the height of the sticky header)
        if (placeholderTop <= 0) {
            placeholderTop += this.stickyHeaderHeight;

            this.$footer.css('top', `${placeholderTop}px`);
        }
    }

    observeFooter() {
        const footerObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.$footer.addClass('is-visible');
            } else {
                this.$footer.removeClass('is-visible');
            }
        });

        footerObserver.observe(this.$footerPlaceholder[0]);
    }
}

export default Footer;
